import * as React from "react";
import { cn } from "@/lib/utils";
import { PathfinderTriangleIcon } from "@/components/ui/PathfinderTriangleIcon";

interface Props {
  title: string;
  className?: string;
}

export const SummaryHeader: React.FC<Props> = ({ title, className }) => (
  <div className={cn("flex items-center gap-2 border-b border-brand-gold-200 pb-3", className)}>
    <PathfinderTriangleIcon size={18} className="text-brand-gold-500" />
    <span className="text-sm font-semibold text-foreground">{title}</span>
  </div>
);
